export default __webpack_public_path__ + "static/media/July2018.cf94be75.png";